import React from "react";

export default function SQLServer_IIF() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_IIF</h1>
      <p>This is the SQLServer_IIF component generated from the SQL JSON.</p>
    </div>
  );
}
